import React from "react";
import Project from "./projet";

export function ProjectInProgress() {
  return <Project status="En cours" />;
}